// Generated from LearnixTa-14-Mobile-Cards-1536x1024/cards.json — matched by destination path, not position.
export const HERO_CARD_COVERS = [
  {
    "to": "/career-clarity",
    "src": "/cards/01-career-clarity-v2.webp",
    "alt": "Career Clarity: two students discuss study choices with a teacher.",
    "title": "Career Clarity"
  },
  {
    "to": "/specializations",
    "src": "/cards/02-specializations.webp",
    "alt": "Inner Specializations: a student compares robotics, electronics, laptop charts and an architectural model at a college workspace.",
    "title": "Inner Specializations"
  },
  {
    "to": "/job-roles",
    "src": "/cards/03-job-roles.webp",
    "alt": "Future-Ready Job Roles: three young professionals discuss a laptop and work diagrams around a shared desk.",
    "title": "Future-Ready Job Roles"
  },
  {
    "to": "/ai-pathway",
    "src": "/cards/04-ai-pathway.webp",
    "alt": "Future AI Agent Pathway: a professional in an ivory blazer works thoughtfully on a laptop in a bright office.",
    "title": "Future AI Agent Pathway"
  },
  {
    "to": "/ai-risk-check",
    "src": "/cards/05-ai-risk-check.webp",
    "alt": "Is AI Coming for Your Role? A professional in a teal shirt sorts task cards beside a laptop at a sunlit desk.",
    "title": "Is AI Coming for Your Role?"
  },
  {
    "to": "/build-badges",
    "src": "/cards/06-build-badges.webp",
    "alt": "Build Badges. Two young professionals discuss a laptop project beside architectural models in a makerspace.",
    "title": "Build Badges"
  },
  {
    "to": "/pathways/internships",
    "src": "/cards/07-internships.webp",
    "alt": "Internship Pathfinder. A guide shows an intern holding a laptop and notebook around a bright office.",
    "title": "Internship Pathfinder"
  },
  {
    "to": "/pathways/fresher-launchpad",
    "src": "/cards/08-fresher-launchpad.webp",
    "alt": "Fresher Launchpad: a young woman presents a cardboard packaging project to a colleague in a bright workspace.",
    "title": "Fresher Launchpad"
  },
  {
    "to": "/pathways/career-switch-growth",
    "src": "/cards/09-career-switch-growth.webp",
    "alt": "Career Switch & Growth: a woman in a purple blouse plans in a notebook beside her laptop and portfolio papers.",
    "title": "Career Switch & Growth"
  },
  {
    "to": "/banking",
    "src": "/cards/10-banking.webp",
    "alt": "Banking Careers: a banker in a teal blazer explains paperwork to a customer across a desk in a modern bank.",
    "title": "Banking Careers"
  },
  {
    "to": "/blue-collar",
    "src": "/cards/11-blue-collar.webp",
    "alt": "Blue-Collar Jobs: a woman repairs an appliance, a salon professional speaks with a client, and a delivery rider holds a helmet beside a parcel.",
    "title": "Blue-Collar Jobs"
  },
  {
    "to": "/ownpath",
    "src": "/cards/12-ownpath.webp",
    "alt": "Entrepreneurship · OwnPath: two founders and an advisor examine a printed textile pouch at a product worktable.",
    "title": "Entrepreneurship · OwnPath"
  },
  {
    "to": "/agriculture",
    "src": "/cards/13-agriculture.webp",
    "alt": "Agriculture: a farmer explains a vegetable plant to a young woman taking notes beside crop rows and a greenhouse.",
    "title": "Agriculture"
  },
  {
    "to": "/life-skills",
    "src": "/cards/14-life-skills.webp",
    "alt": "Life Skills — For Every Future: two young adults listen to a woman mentor at a library table with notebooks.",
    "title": "Life Skills — For Every Future"
  },
  {
    "to": "/the-ai-shift",
    "src": "/cards/15-the-ai-shift.webp",
    "alt": "LearnixTa: The AI Shift — Prepare Now. AI • AGI • ASI. Indian young adults with a notebook and laptop face a humanoid robot in a city of workshops, gardens and skill spaces. Understand the forecasts. Build practical options.",
    "title": "The AI Shift — Prepare Now"
  }
];
